import { render, staticRenderFns } from "./settingStaff.vue?vue&type=template&id=4c536d82&scoped=true"
import script from "./settingStaff.vue?vue&type=script&lang=js"
export * from "./settingStaff.vue?vue&type=script&lang=js"
import style0 from "./settingStaff.vue?vue&type=style&index=0&id=4c536d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c536d82",
  null
  
)

export default component.exports